import type { CompetitorDomain } from "./models.js";

export function competitorMatchesSearch(
  competitor: CompetitorDomain,
  search: string | undefined,
): boolean {
  const normalizedSearch = search?.trim().toLowerCase();
  if (normalizedSearch === undefined || normalizedSearch.length === 0) return true;

  return (
    competitor.name.toLowerCase().startsWith(normalizedSearch) ||
    competitor.normalizedHost === normalizedSearchHost(normalizedSearch)
  );
}

function normalizedSearchHost(search: string): string {
  if (!search.includes(".")) {
    return search;
  }

  try {
    return new URL(search.includes("://") ? search : `https://${search}`).hostname
      .toLowerCase()
      .replace(/^www\./u, "");
  } catch {
    return search;
  }
}
